module.exports = __webpack_public_path__ + "img/down.6c9d6b18.svg";